import { useNavigate } from 'react-router-dom';
import { buildAutomationEditPath } from '../../../../../app-routes';
import { Button } from '../../../../../components/ui/button';
import type { AutomationTemplate } from '../../templates.types';
import { CopyTemplateButton } from './CopyTemplateButton';
import rowStyles from './TemplatesTableRow.module.css';

interface TemplatesTableRowProps {
  template: AutomationTemplate;
}

export function TemplatesTableRow({ template }: TemplatesTableRowProps) {
  const navigate = useNavigate();

  const handleEditTemplate = () => {
    navigate(buildAutomationEditPath(template.id));
  };

  return (
    <tr className={rowStyles.tableRow} onClick={handleEditTemplate}>
      <td>{template.contents?.name || template.name}</td>
      <td>{template.contents?.description || '-'}</td>
      <td>
        <Button
          onClick={e => {
            e.stopPropagation();
            handleEditTemplate();
          }}
          variant="ghost"
          size="sm"
          className={rowStyles.editButton}>
          Edit
        </Button>
        <CopyTemplateButton template={template} />
      </td>
    </tr>
  );
}
